/* tslint:disable */
/* eslint-disable */
/**
 * Airline API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import * as runtime from '../runtime.js';
import { CheckDgContractVerificationCodeRequestToJSON, CheckDgContractVerificationCodeResponseFromJSON, CompleteDgExerciseRequestToJSON, CreateDgContractExerciseRequestToJSON, CreateDgContractExerciseResponseFromJSON, CreateDgContractRequestToJSON, CreateDgOfferItemResponseFromJSON, CreateDgOffersRequestToJSON, CreateDgRefundAuthorizationRequestToJSON, CreateDgRefundRecipientRequestToJSON, DgContractFromJSON, DgEventToJSON, DgExerciseFromJSON, DgPaymentFromJSON, DgProcessRebookingCustomerRequestToJSON, DgRefundAuthorizationFromJSON, DgRefundRecipientFromJSON, DgSearchAlternativesCustomerRequestToJSON, DgSearchAlternativesCustomerResponseFromJSON, ProcessDgPaymentRequestToJSON, SendDgContractVerificationCodeRequestToJSON, SendDgContractVerificationCodeResponseFromJSON, UpdateDgContractStatusRequestToJSON, } from '../models/index.js';
/**
 *
 */
export class DisruptionGuaranteeDGApi extends runtime.BaseAPI {
    /**
     * Create a new event for analytics using a tracking pixel
     * Create an Event using a tracking pixel
     */
    getCustomerDgAnalyticsHcsessionidEventnameRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.hcSessionId === null || requestParameters.hcSessionId === undefined) {
                throw new runtime.RequiredError('hcSessionId', 'Required parameter requestParameters.hcSessionId was null or undefined when calling getCustomerDgAnalyticsHcsessionidEventname.');
            }
            if (requestParameters.eventName === null || requestParameters.eventName === undefined) {
                throw new runtime.RequiredError('eventName', 'Required parameter requestParameters.eventName was null or undefined when calling getCustomerDgAnalyticsHcsessionidEventname.');
            }
            const queryParameters = {};
            const headerParameters = {};
            const response = yield this.request({
                path: `/customer/dg/analytics/{hcSessionId}/{eventName}`.replace(`{${"hcSessionId"}}`, encodeURIComponent(String(requestParameters.hcSessionId))).replace(`{${"eventName"}}`, encodeURIComponent(String(requestParameters.eventName))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.BlobApiResponse(response);
        });
    }
    /**
     * Create a new event for analytics using a tracking pixel
     * Create an Event using a tracking pixel
     */
    getCustomerDgAnalyticsHcsessionidEventname(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getCustomerDgAnalyticsHcsessionidEventnameRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Get a DG contract
     * Get a DG contract
     */
    getDgContractsIdRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getDgContractsId.');
            }
            const queryParameters = {};
            const headerParameters = {};
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["HC-Session-ID"] = this.configuration.apiKey("HC-Session-ID"); // SessionAuth authentication
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("PartnerAuth", []);
            }
            const response = yield this.request({
                path: `/dg_contracts/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'GET',
                headers: headerParameters,
                query: queryParameters,
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DgContractFromJSON(jsonValue));
        });
    }
    /**
     * Get a DG contract
     * Get a DG contract
     */
    getDgContractsId(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.getDgContractsIdRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Retrieve alternatives associated with a DG exercise
     * Retrieve alternatives associated with a DG exercise
     */
    postCustomerDgAlternativesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.dgSearchAlternativesCustomerRequest === null || requestParameters.dgSearchAlternativesCustomerRequest === undefined) {
                throw new runtime.RequiredError('dgSearchAlternativesCustomerRequest', 'Required parameter requestParameters.dgSearchAlternativesCustomerRequest was null or undefined when calling postCustomerDgAlternatives.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.verificationCode !== undefined && requestParameters.verificationCode !== null) {
                headerParameters['verification-code'] = String(requestParameters.verificationCode);
            }
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["HC-Session-ID"] = this.configuration.apiKey("HC-Session-ID"); // SessionAuth authentication
            }
            const response = yield this.request({
                path: `/customer/dg/alternatives`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: DgSearchAlternativesCustomerRequestToJSON(requestParameters.dgSearchAlternativesCustomerRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DgSearchAlternativesCustomerResponseFromJSON(jsonValue));
        });
    }
    /**
     * Retrieve alternatives associated with a DG exercise
     * Retrieve alternatives associated with a DG exercise
     */
    postCustomerDgAlternatives(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCustomerDgAlternativesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Check a verification code sent to a user and required to process a DG exercise
     * Check a verification code associated with a DG contract or Dg exercise and respond with the corresponding exercise
     */
    postCustomerDgCheckVerificationCodeRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.checkDgContractVerificationCodeRequest === null || requestParameters.checkDgContractVerificationCodeRequest === undefined) {
                throw new runtime.RequiredError('checkDgContractVerificationCodeRequest', 'Required parameter requestParameters.checkDgContractVerificationCodeRequest was null or undefined when calling postCustomerDgCheckVerificationCode.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/customer/dg/check_verification_code`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CheckDgContractVerificationCodeRequestToJSON(requestParameters.checkDgContractVerificationCodeRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CheckDgContractVerificationCodeResponseFromJSON(jsonValue));
        });
    }
    /**
     * Check a verification code sent to a user and required to process a DG exercise
     * Check a verification code associated with a DG contract or Dg exercise and respond with the corresponding exercise
     */
    postCustomerDgCheckVerificationCode(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCustomerDgCheckVerificationCodeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create a new event for analytics
     * Create an Event
     */
    postCustomerDgEventsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.dgEvent === null || requestParameters.dgEvent === undefined) {
                throw new runtime.RequiredError('dgEvent', 'Required parameter requestParameters.dgEvent was null or undefined when calling postCustomerDgEvents.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["HC-Session-ID"] = this.configuration.apiKey("HC-Session-ID"); // SessionAuth authentication
            }
            const response = yield this.request({
                path: `/customer/dg/events`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: DgEventToJSON(requestParameters.dgEvent),
            }, initOverrides);
            return new runtime.VoidApiResponse(response);
        });
    }
    /**
     * Create a new event for analytics
     * Create an Event
     */
    postCustomerDgEvents(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.postCustomerDgEventsRaw(requestParameters, initOverrides);
        });
    }
    /**
     * Record that a request to exercise a CFAR contract has been completed
     * Complete Dg Exercise
     */
    postCustomerDgMarkCompletedRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.completeDgExerciseRequest === null || requestParameters.completeDgExerciseRequest === undefined) {
                throw new runtime.RequiredError('completeDgExerciseRequest', 'Required parameter requestParameters.completeDgExerciseRequest was null or undefined when calling postCustomerDgMarkCompleted.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.verificationCode !== undefined && requestParameters.verificationCode !== null) {
                headerParameters['verification-code'] = String(requestParameters.verificationCode);
            }
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["HC-Session-ID"] = this.configuration.apiKey("HC-Session-ID"); // SessionAuth authentication
            }
            const response = yield this.request({
                path: `/customer/dg/mark_completed`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CompleteDgExerciseRequestToJSON(requestParameters.completeDgExerciseRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DgExerciseFromJSON(jsonValue));
        });
    }
    /**
     * Record that a request to exercise a CFAR contract has been completed
     * Complete Dg Exercise
     */
    postCustomerDgMarkCompleted(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCustomerDgMarkCompletedRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Process a rebooking on an alternative flight in association with a DG exercise
     * Rebook on an alternative in association with a DG exercise
     */
    postCustomerDgRebookRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.dgProcessRebookingCustomerRequest === null || requestParameters.dgProcessRebookingCustomerRequest === undefined) {
                throw new runtime.RequiredError('dgProcessRebookingCustomerRequest', 'Required parameter requestParameters.dgProcessRebookingCustomerRequest was null or undefined when calling postCustomerDgRebook.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.verificationCode !== undefined && requestParameters.verificationCode !== null) {
                headerParameters['verification-code'] = String(requestParameters.verificationCode);
            }
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["HC-Session-ID"] = this.configuration.apiKey("HC-Session-ID"); // SessionAuth authentication
            }
            const response = yield this.request({
                path: `/customer/dg/rebook`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: DgProcessRebookingCustomerRequestToJSON(requestParameters.dgProcessRebookingCustomerRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response);
        });
    }
    /**
     * Process a rebooking on an alternative flight in association with a DG exercise
     * Rebook on an alternative in association with a DG exercise
     */
    postCustomerDgRebook(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCustomerDgRebookRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create a Refund Authorization Token
     * Create a Refund Authorization Token
     */
    postCustomerDgRefundAuthorizationsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.createDgRefundAuthorizationRequest === null || requestParameters.createDgRefundAuthorizationRequest === undefined) {
                throw new runtime.RequiredError('createDgRefundAuthorizationRequest', 'Required parameter requestParameters.createDgRefundAuthorizationRequest was null or undefined when calling postCustomerDgRefundAuthorizations.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.verificationCode !== undefined && requestParameters.verificationCode !== null) {
                headerParameters['verification-code'] = String(requestParameters.verificationCode);
            }
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["HC-Session-ID"] = this.configuration.apiKey("HC-Session-ID"); // SessionAuth authentication
            }
            const response = yield this.request({
                path: `/customer/dg/refund_authorizations`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateDgRefundAuthorizationRequestToJSON(requestParameters.createDgRefundAuthorizationRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DgRefundAuthorizationFromJSON(jsonValue));
        });
    }
    /**
     * Create a Refund Authorization Token
     * Create a Refund Authorization Token
     */
    postCustomerDgRefundAuthorizations(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCustomerDgRefundAuthorizationsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create a Refund Recipient
     * Create a Refund Recipient
     */
    postCustomerDgRefundRecipientsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.createDgRefundRecipientRequest === null || requestParameters.createDgRefundRecipientRequest === undefined) {
                throw new runtime.RequiredError('createDgRefundRecipientRequest', 'Required parameter requestParameters.createDgRefundRecipientRequest was null or undefined when calling postCustomerDgRefundRecipients.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.verificationCode !== undefined && requestParameters.verificationCode !== null) {
                headerParameters['verification-code'] = String(requestParameters.verificationCode);
            }
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["HC-Session-ID"] = this.configuration.apiKey("HC-Session-ID"); // SessionAuth authentication
            }
            const response = yield this.request({
                path: `/customer/dg/refund_recipients`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateDgRefundRecipientRequestToJSON(requestParameters.createDgRefundRecipientRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DgRefundRecipientFromJSON(jsonValue));
        });
    }
    /**
     * Create a Refund Recipient
     * Create a Refund Recipient
     */
    postCustomerDgRefundRecipients(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCustomerDgRefundRecipientsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Send a verification code to a user required to process a DG exercise
     * Send a verification code associated with a DG contract
     */
    postCustomerDgSendVerificationCodeRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.sendDgContractVerificationCodeRequest === null || requestParameters.sendDgContractVerificationCodeRequest === undefined) {
                throw new runtime.RequiredError('sendDgContractVerificationCodeRequest', 'Required parameter requestParameters.sendDgContractVerificationCodeRequest was null or undefined when calling postCustomerDgSendVerificationCode.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            const response = yield this.request({
                path: `/customer/dg/send_verification_code`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: SendDgContractVerificationCodeRequestToJSON(requestParameters.sendDgContractVerificationCodeRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => SendDgContractVerificationCodeResponseFromJSON(jsonValue));
        });
    }
    /**
     * Send a verification code to a user required to process a DG exercise
     * Send a verification code associated with a DG contract
     */
    postCustomerDgSendVerificationCode(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postCustomerDgSendVerificationCodeRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Record that a request to exercise a DG contract has occurred.
     * Create DG Exercise
     */
    postDgContractExercisesRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.createDgContractExerciseRequest === null || requestParameters.createDgContractExerciseRequest === undefined) {
                throw new runtime.RequiredError('createDgContractExerciseRequest', 'Required parameter requestParameters.createDgContractExerciseRequest was null or undefined when calling postDgContractExercises.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.hCSessionID !== undefined && requestParameters.hCSessionID !== null) {
                headerParameters['HC-Session-ID'] = String(requestParameters.hCSessionID);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("PartnerAuth", []);
            }
            const response = yield this.request({
                path: `/dg_contract_exercises`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateDgContractExerciseRequestToJSON(requestParameters.createDgContractExerciseRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => CreateDgContractExerciseResponseFromJSON(jsonValue));
        });
    }
    /**
     * Record that a request to exercise a DG contract has occurred.
     * Create DG Exercise
     */
    postDgContractExercises(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postDgContractExercisesRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create a DG contract from selected DG offer(s).
     * Create a DG Contract
     */
    postDgContractsRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.createDgContractRequest === null || requestParameters.createDgContractRequest === undefined) {
                throw new runtime.RequiredError('createDgContractRequest', 'Required parameter requestParameters.createDgContractRequest was null or undefined when calling postDgContracts.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["HC-Session-ID"] = this.configuration.apiKey("HC-Session-ID"); // SessionAuth authentication
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("PartnerAuth", []);
            }
            const response = yield this.request({
                path: `/dg_contracts`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateDgContractRequestToJSON(requestParameters.createDgContractRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DgContractFromJSON(jsonValue));
        });
    }
    /**
     * Create a DG contract from selected DG offer(s).
     * Create a DG Contract
     */
    postDgContracts(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postDgContractsRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * When HTS is the Merchant of Record (MoR), the customer\'s credit card is charged by HTS for the DG fee.  HTS is relying on an external payment gateway to process the payments, it allows the partner airline to tokenize the customer\'s credit card details and then pass the generated token in HTS Ancillaries for Airlines API payment endpoints in order to process the payment and confirm the contract related to the purchased product.  **Token URL**: https://core.spreedly.com/v1/payment_methods.json    **Example Token Request**:      ```   curl --request POST --url https://core.spreedly.com/v1/payment_methods.json --header \'content-type: application/json\' -u  \"login:password\" --data \'{  \"payment_method\": {   \"email\": \"aaa@bbb.ccc\",   \"credit_card\": {    \"number\": \"4111111111111111\",    \"month\": \"09\",    \"year\": \"2029\",    \"first_name\": \"John\",    \"last_name\": \"Smith\",    \"address1\": \"123 12th St\",    \"address2\": \"Building B\",    \"city\": \"Quebec City\",    \"state\": \"QC\",    \"zip\": \"G1R 4S9\",    \"country\": \"CA\",    \"verification_value\": \"123\"   }  } }\' ``` **Example Token Response**:   ```   {  \"transaction\":  {   \"token\":  \"KtToV20m9qT1Yi8pbTeLNz0Ypns\",   \"created_at\":  \"2023-11-29T13:31:56Z\",   \"updated_at\":  \"2023-11-29T13:31:56Z\",   \"succeeded\":  true,   \"transaction_type\":  \"AddPaymentMethod\",   \"retained\":  false,   \"state\":  \"succeeded\",   \"message_key\":  \"messages.transaction_succeeded\",   \"message\":  \"Succeeded!\",   \"payment_method\":  {    \"token\":  \"MxyYEhDK12CUAA18bJDkAq0ab3y\",    \"created_at\":  \"2023-11-29T13:31:56Z\",    \"updated_at\":  \"2023-11-29T13:31:56Z\",    \"email\":  \"aaa@bbb.ccc\",    \"data\":  null,    \"storage_state\":  \"cached\",    \"test\":  true,    \"metadata\":  null,    \"callback_url\":  null,    \"last_four_digits\":  \"1111\",    \"first_six_digits\":  \"411111\",    \"card_type\":  \"visa\",    \"first_name\":  \"John\",    \"last_name\":  \"Smith\",    \"month\":  9,    \"year\":  2029,    \"address1\":  \"123 12th St\",    \"address2\":  \"Building B\",    \"city\":  \"Quebec City\",    \"state\":  \"QC\",    \"zip\":  \"G1R 4S9\",    \"country\":  \"CA\",    \"phone_number\":  null,    \"company\":  null,    \"full_name\":  \"John Smith\",    \"eligible_for_card_updater\":  true,    \"shipping_address1\":  null,    \"shipping_address2\":  null,    \"shipping_city\":  null,    \"shipping_state\":  null,    \"shipping_zip\":  null,    \"shipping_country\":  null,    \"shipping_phone_number\":  null,    \"issuer_identification_number\":  \"41111111\",    \"click_to_pay\":  false,    \"managed\":  true,    \"payment_method_type\":  \"credit_card\",    \"errors\":  [],    \"bin_metadata\":  {     \"message\":  \"BIN Metadata is available only to Advanced Vault enrolled customers and payment methods. Reach out to your account representative for more details.\"    },    \"fingerprint\":  \"7ccffcf38900f224fc946cf2a9c8e260072b\",    \"verification_value\":  \"XXX\",    \"number\":  \"XXXX-XXXX-XXXX-1111\"   }  } } ``` Here the returned payment method token **MxyYEhDK12CUAA18bJDkAq0ab3y** has to be used in the Process DG Payment request below.
     * Process DG payment
     */
    postDgContractsIdPaymentRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling postDgContractsIdPayment.');
            }
            if (requestParameters.processDgPaymentRequest === null || requestParameters.processDgPaymentRequest === undefined) {
                throw new runtime.RequiredError('processDgPaymentRequest', 'Required parameter requestParameters.processDgPaymentRequest was null or undefined when calling postDgContractsIdPayment.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["HC-Session-ID"] = this.configuration.apiKey("HC-Session-ID"); // SessionAuth authentication
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("PartnerAuth", []);
            }
            const response = yield this.request({
                path: `/dg_contracts/{id}/payment`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: ProcessDgPaymentRequestToJSON(requestParameters.processDgPaymentRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DgPaymentFromJSON(jsonValue));
        });
    }
    /**
     * When HTS is the Merchant of Record (MoR), the customer\'s credit card is charged by HTS for the DG fee.  HTS is relying on an external payment gateway to process the payments, it allows the partner airline to tokenize the customer\'s credit card details and then pass the generated token in HTS Ancillaries for Airlines API payment endpoints in order to process the payment and confirm the contract related to the purchased product.  **Token URL**: https://core.spreedly.com/v1/payment_methods.json    **Example Token Request**:      ```   curl --request POST --url https://core.spreedly.com/v1/payment_methods.json --header \'content-type: application/json\' -u  \"login:password\" --data \'{  \"payment_method\": {   \"email\": \"aaa@bbb.ccc\",   \"credit_card\": {    \"number\": \"4111111111111111\",    \"month\": \"09\",    \"year\": \"2029\",    \"first_name\": \"John\",    \"last_name\": \"Smith\",    \"address1\": \"123 12th St\",    \"address2\": \"Building B\",    \"city\": \"Quebec City\",    \"state\": \"QC\",    \"zip\": \"G1R 4S9\",    \"country\": \"CA\",    \"verification_value\": \"123\"   }  } }\' ``` **Example Token Response**:   ```   {  \"transaction\":  {   \"token\":  \"KtToV20m9qT1Yi8pbTeLNz0Ypns\",   \"created_at\":  \"2023-11-29T13:31:56Z\",   \"updated_at\":  \"2023-11-29T13:31:56Z\",   \"succeeded\":  true,   \"transaction_type\":  \"AddPaymentMethod\",   \"retained\":  false,   \"state\":  \"succeeded\",   \"message_key\":  \"messages.transaction_succeeded\",   \"message\":  \"Succeeded!\",   \"payment_method\":  {    \"token\":  \"MxyYEhDK12CUAA18bJDkAq0ab3y\",    \"created_at\":  \"2023-11-29T13:31:56Z\",    \"updated_at\":  \"2023-11-29T13:31:56Z\",    \"email\":  \"aaa@bbb.ccc\",    \"data\":  null,    \"storage_state\":  \"cached\",    \"test\":  true,    \"metadata\":  null,    \"callback_url\":  null,    \"last_four_digits\":  \"1111\",    \"first_six_digits\":  \"411111\",    \"card_type\":  \"visa\",    \"first_name\":  \"John\",    \"last_name\":  \"Smith\",    \"month\":  9,    \"year\":  2029,    \"address1\":  \"123 12th St\",    \"address2\":  \"Building B\",    \"city\":  \"Quebec City\",    \"state\":  \"QC\",    \"zip\":  \"G1R 4S9\",    \"country\":  \"CA\",    \"phone_number\":  null,    \"company\":  null,    \"full_name\":  \"John Smith\",    \"eligible_for_card_updater\":  true,    \"shipping_address1\":  null,    \"shipping_address2\":  null,    \"shipping_city\":  null,    \"shipping_state\":  null,    \"shipping_zip\":  null,    \"shipping_country\":  null,    \"shipping_phone_number\":  null,    \"issuer_identification_number\":  \"41111111\",    \"click_to_pay\":  false,    \"managed\":  true,    \"payment_method_type\":  \"credit_card\",    \"errors\":  [],    \"bin_metadata\":  {     \"message\":  \"BIN Metadata is available only to Advanced Vault enrolled customers and payment methods. Reach out to your account representative for more details.\"    },    \"fingerprint\":  \"7ccffcf38900f224fc946cf2a9c8e260072b\",    \"verification_value\":  \"XXX\",    \"number\":  \"XXXX-XXXX-XXXX-1111\"   }  } } ``` Here the returned payment method token **MxyYEhDK12CUAA18bJDkAq0ab3y** has to be used in the Process DG Payment request below.
     * Process DG payment
     */
    postDgContractsIdPayment(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postDgContractsIdPaymentRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Create DG offers for a user\'s trip
     * Create DG Offers
     */
    postDgOffersRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.createDgOffersRequest === null || requestParameters.createDgOffersRequest === undefined) {
                throw new runtime.RequiredError('createDgOffersRequest', 'Required parameter requestParameters.createDgOffersRequest was null or undefined when calling postDgOffers.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (requestParameters.hCSessionID !== undefined && requestParameters.hCSessionID !== null) {
                headerParameters['HC-Session-ID'] = String(requestParameters.hCSessionID);
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("PartnerAuth", []);
            }
            const response = yield this.request({
                path: `/dg_offers`,
                method: 'POST',
                headers: headerParameters,
                query: queryParameters,
                body: CreateDgOffersRequestToJSON(requestParameters.createDgOffersRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(CreateDgOfferItemResponseFromJSON));
        });
    }
    /**
     * Create DG offers for a user\'s trip
     * Create DG Offers
     */
    postDgOffers(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.postDgOffersRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
    /**
     * Update DG Contract Status
     * Update DG Contract Status
     */
    putDgContractsIdUpdateStatusRaw(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            if (requestParameters.id === null || requestParameters.id === undefined) {
                throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling putDgContractsIdUpdateStatus.');
            }
            if (requestParameters.updateDgContractStatusRequest === null || requestParameters.updateDgContractStatusRequest === undefined) {
                throw new runtime.RequiredError('updateDgContractStatusRequest', 'Required parameter requestParameters.updateDgContractStatusRequest was null or undefined when calling putDgContractsIdUpdateStatus.');
            }
            const queryParameters = {};
            const headerParameters = {};
            headerParameters['Content-Type'] = 'application/json';
            if (this.configuration && this.configuration.apiKey) {
                headerParameters["HC-Session-ID"] = this.configuration.apiKey("HC-Session-ID"); // SessionAuth authentication
            }
            if (this.configuration && this.configuration.accessToken) {
                // oauth required
                headerParameters["Authorization"] = yield this.configuration.accessToken("PartnerAuth", []);
            }
            const response = yield this.request({
                path: `/dg_contracts/{id}/update_status`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
                method: 'PUT',
                headers: headerParameters,
                query: queryParameters,
                body: UpdateDgContractStatusRequestToJSON(requestParameters.updateDgContractStatusRequest),
            }, initOverrides);
            return new runtime.JSONApiResponse(response, (jsonValue) => DgContractFromJSON(jsonValue));
        });
    }
    /**
     * Update DG Contract Status
     * Update DG Contract Status
     */
    putDgContractsIdUpdateStatus(requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function* () {
            const response = yield this.putDgContractsIdUpdateStatusRaw(requestParameters, initOverrides);
            return yield response.value();
        });
    }
}
